import { MAT_DATE_FORMATS } from '@angular/material/core';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY', // Formato de entrada al escribir manualmente
  },
  display: {
    dateInput: 'DD/MM/YYYY', // Formato de visualización en el input
    monthYearLabel: 'MMMM YYYY', // Formato para etiquetas de mes/año
    dateA11yLabel: 'LL', // Formato accesible
    monthYearA11yLabel: 'MMMM YYYY', // Formato accesible para mes/año
  },
};